export const host = "https://api-explorer.authing.cn/";
